import Seo from "@/components/Seo";
import { FadeIn, Eyebrow } from "@/components/Reveal";
import { COMPANY } from "@/data/siteData";

const SECTIONS = [
  { title: "Information we collect", body: "When you submit an enquiry on this website, we collect your name, company name, phone number, email address, city, the type of insurance you are enquiring about, and any message you choose to share. We do not collect payment information on this website." },
  { title: "How we use your information", body: "We use the information you provide solely to respond to your enquiry, understand your insurance requirements, and communicate with you about the covers you have asked about. We do not send unsolicited marketing messages." },
  { title: "Sharing of information", body: "As an insurance broker, we may share relevant details with insurance companies only where necessary to obtain quotes or place the cover you have requested. We do not sell, rent or trade your personal information to any third party." },
  { title: "Data storage and security", body: "Enquiry details are stored securely and access is restricted to authorised personnel. We retain enquiry records only for as long as needed to serve you and to meet regulatory obligations applicable to insurance brokers in India." },
  { title: "Your rights", body: "You may ask us at any time to correct or delete the personal information we hold about you, by writing to our grievance contact listed in the footer of this website." },
  { title: "Changes to this policy", body: "We may update this Privacy Policy from time to time. The version published on this page is the version currently in effect." },
];

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-policy-page">
      <Seo
        title="Privacy Policy | Wisdom Insurance Broking Private Limited"
        description="Privacy policy of Wisdom Insurance Broking Private Limited — how we collect, use and protect the information you share with us."
      />
      <section className="grain bg-navy-deep pb-16 pt-32 md:pb-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
          <FadeIn>
            <Eyebrow light>Legal</Eyebrow>
            <h1 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-white sm:text-5xl">Privacy Policy</h1>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-slate-400">{COMPANY.name}</p>
          </FadeIn>
        </div>
      </section>
      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-8 lg:px-0">
        {SECTIONS.map((s, i) => (
          <FadeIn key={s.title} delay={i * 0.04} className="border-b border-slate-200 py-8 first:pt-0">
            <h2 className="font-heading text-lg font-semibold text-navy">{i + 1}. {s.title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.body}</p>
          </FadeIn>
        ))}
      </section>
    </div>
  );
}
